import { BrowserRouter, Redirect, Route, Switch } from "react-router-dom";
import React, { useContext } from "react";

import HomePage from "./pages/HomePage";
import LoginPage from "./pages/LoginPage";
import NewScreeningRequestsDetailPage from "./pages/CancerScreening/NewScreeningRequestsDetailPage";
import NewScreeningRequestsPage from "./pages/CancerScreening/NewScreeningRequestsPage";
import NotFoundPage from "./pages/NotFoundPage";
import ScreeningRequestsOverviewDetailPage from "./pages/CancerScreening/ScreeningRequestsOverviewDetailPage";
import ScreeningRequestsOverviewPage from "./pages/CancerScreening/ScreeningRequestsOverviewPage";
import SentScreeningRequestsDetailPage from "./pages/CancerScreening/SentScreeningRequestsDetailPage";
import SentScreeningRequestsPage from "./pages/CancerScreening/SentScreeningRequestsPage";
import { UserContext } from "./context/UserContext";
import UserControlPage from "./pages/UserControlPage";
import { accessControl } from "./constants/enums";
import { hasUserAccess } from "./utils";

const Routes = () => {
  const [user] = useContext(UserContext);

  return getSamplingRouter();

  function getSamplingRouter() {
    let sentScreeningRequestsIndex = 0;
    let newScreeningRequestsIndex = 0;

    return (
      <BrowserRouter>
        <Switch>
          <Redirect exact from="/" to="/login" />
          <Route path="/login" exact component={LoginPage} />
          <Route path="/home" exact component={HomePage} />
          {hasUserAccess(accessControl.NEW_SCREENING_REQUESTS, user) && [
            <Route
              key={newScreeningRequestsIndex++}
              path="/new-screening-requests"
              exact
              component={NewScreeningRequestsPage}
            />,
            <Route
              key={newScreeningRequestsIndex++}
              path="/new-screening-requests/:id"
              exact
              component={NewScreeningRequestsDetailPage}
            />,
          ]}
          {(hasUserAccess(accessControl.SENT_SCREENING_REQUESTS_FULL_ACCESS, user)
            || hasUserAccess(accessControl.SENT_SCREENING_REQUESTS_PATHOLOGISTS, user)) && [
            <Route
              key={sentScreeningRequestsIndex++}
              path="/sent-screening-requests"
              exact
              component={SentScreeningRequestsPage}
            />,
            <Route
              key={sentScreeningRequestsIndex++}
              path="/sent-screening-request/:id"
              exact
              component={SentScreeningRequestsDetailPage}
            />,
          ]}
          {hasUserAccess(accessControl.SCREENING_REQUESTS_OVERVIEW, user) && [
            <Route path="/screening-requests-overview" exact component={ScreeningRequestsOverviewPage} />,
            <Route path="/screening-request-overview/:id" exact component={ScreeningRequestsOverviewDetailPage} />
          ]}
          {hasUserAccess(accessControl.SUPER_ADMIN, user) && (
            <Route path="/access-control" exact component={UserControlPage} />
          )}
          {/* <Route path="/help" exact component={HelpPage} /> */}
          <Route component={NotFoundPage} />
        </Switch>
      </BrowserRouter>
    );
  }
};

export default Routes;
